import { useEffect, useState } from 'react';
import httpClient from '../../../../services/http';
import { APIUtils } from '../../../../utils/apiutils';

const useFetchExecs = () => {
    const [execs, setExecs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        const fetchData = async () => {
            setLoading(true);
            try {
                const url = APIUtils.getAdminAPIEndpoint('exec-list');
                const res = await httpClient.get(url, { signal: controller.signal }).then(res => res.data);
                if (res.status === 'success') {
                    setExecs(res.data);
                }
            } catch (e) {
                console.log(e);
                setError(e);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

        return () => {
            controller.abort();
        };
    }, []);

    return { execs, loading, error };
};

export default useFetchExecs;